import React from 'react'
import PropTypes from 'prop-types'
import { map, isEmpty } from 'lodash'
import cn from 'classnames'

import CartItem from './CartItem'

import { ReactComponent as CartIcon } from '../assets/icons/cart-icon.svg'

import styles from './CartItems.module.scss'

const CartItems = ({ cartItems, onRemove, onSelect, newItemFocus, clearFocus, className }) => {
  const classNames = cn(styles.cartItems, className)
  let emptyElement = null

  if (isEmpty(cartItems)) {
    emptyElement = (
      <div className={styles.empty}>
        <CartIcon />
        <p>Add items to your cart</p>
      </div>
    )
  }

  return (
    <div className={classNames}>
      {emptyElement}
      {map(cartItems, (cartItem, index, items) => (
        <CartItem
          key={`${cartItem.id}-${index}`}
          {...cartItem}
          modifiers={cartItem.modifiersString}
          onRemove={() => onRemove(index)}
          onSelect={() => onSelect(index)}
          className={styles.cartItem}
          focusItem={newItemFocus && (index === items.length -1)}
          clearFocus={clearFocus}
        />
      ))}
    </div>
  )
}

CartItems.propTypes = {
  cartItems: [],
  onRemove: () => {},
  onSelect: () => {},
}

CartItems.propTypes = {
  cartItems: PropTypes.arrayOf(PropTypes.object),
  onRemove: PropTypes.func,
  onSelect: PropTypes.func,
  className: PropTypes.string,
}

export default CartItems
